import succes from "assets/svg/check.svg";
import error from "assets/svg/red-cross.svg";
import "./Input.css";

const InputField = ({
  id,
  className,
  label,
  type = "text",
  value,
  uniqueName,
  defaultValue,
  placeholder,
  onChange,
  disabled,
  onBlur,
  isValid,
  validationMessage,
  showValidation,
  hasPasswordToggle,
  autoComplete,
  inputRef,
  customWidth, // Add a customWidth prop
  ...props
}) => {
  return (
  <div className={`input ${className}`} style={{ width: customWidth }}> {/* Apply custom width */}
      <label htmlFor={id}>
        {label}
        {isValid ? (
          <span className={showValidation ? "error-message" : "hide-message"}>
            <img src={succes} alt="correct" />
          </span>
        ) : (
          <span className={showValidation ? "error-message" : "hide-message"}>
            <img src={error} alt="error" />
          </span>
        )}
      </label>
      <input
        id={id}
        type={type}
        name={uniqueName}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        disabled={disabled}
        onBlur={onBlur}
        aria-invalid={!isValid}
        placeholder={placeholder}
        autoComplete={autoComplete}
        ref={inputRef}
        {...props}
      />
      {!isValid && showValidation && validationMessage && (
        <p className="error-message">{validationMessage}</p>
      )}
    </div>
  );
};

export default InputField;
